"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledCountdown = require("./StyledCountdown");
var _excluded = ["time"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Countdown = function Countdown(props) {
  var time = props.time,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(time),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    countdown = _useState2[0],
    setCountdown = _useState2[1];
  (0, _react.useEffect)(function () {
    var timer = setInterval(function () {
      setCountdown(function (countdown) {
        if (countdown === 0) {
          clearInterval(timer);
          return 0;
        } else return countdown - 1;
      });
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledCountdown.StyledCountdown, null, /*#__PURE__*/_react.default.createElement(_StyledCountdown.StyledTime, null, "".concat(countdown).padStart(2, 0)), " Saniye");
  });
};
Countdown.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  time: _propTypes.default.number
};
Countdown.defaultProps = {
  className: '',
  time: 3000
};
var _default = exports.default = Countdown;